<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/input" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">输入框</div>
        <div class="sub-title">普通用法</div>
        <pre v-highlightjs="code1"><code class="html"></code></pre>

        <div class="sub-title">多行输入</div>
        <pre v-highlightjs="code2"><code class="html"></code></pre>

        <div class="sub-title">自动光标</div>
        <pre v-highlightjs="code3"><code class="html"></code></pre>

        <div class="sub-title">可清除输入</div>
        <pre v-highlightjs="code4"><code class="html"></code></pre>

        <div class="sub-title">无标题</div>
        <pre v-highlightjs="code5"><code class="html"></code></pre>

        <div class="sub-title">自定义图标/图片/组件</div>
        <pre v-highlightjs="code6"><code class="html"></code></pre>

        <div class="sub-title">自定义后缀</div>
        <pre v-highlightjs="code7"><code class="html"></code></pre>

        <div class="sub-title">格式</div>
        <pre v-highlightjs="code8"><code class="html"></code></pre>

        <div class="sub-title">只读</div>
        <pre v-highlightjs="code9"><code class="html"></code></pre>

        <div class="sub-title">禁用</div>
        <pre v-highlightjs="code10"><code class="html"></code></pre>

        <div class="sub-title">输入组</div>
        <pre v-highlightjs="code11"><code class="html"></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>

        <div class="sub-title">事件</div>
        <yu-table :data="attributes2" :widths="widths2"/>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
  <yu-input title="名字" placeholder="请输入名字" name="myname1"/>
      `,
      code2: `
  <yu-input title="名字"
            placeholder="请输入名字"
            name="myname1"
            textarea
            :rows="2"
            :max="5"
            wordCount/>
      `,
      code3: `
  <yu-input title="名字" placeholder="请输入名字" name="myname2" autofocus />
      `,
      code4: `
  <yu-input title="名字" placeholder="请输入名字" name="myname3" clear/>
      `,
      code5: `
  <yu-input title="名字" placeholder="请输入名字" name="myname4"/>
      `,
      code6: `
  <yu-input icon="icon-user" placeholder="请输入名字" name="myname"/>
  <yu-input
  img-src="https://zos.alipayobjects.com/rmsportal/dNuvNrtqUztHCwM.png"
  placeholder="请输入名字"
  name="myname5"/>
      `,
      code7: `
  <yu-input title="名字" placeholder="请输入名字" name="myname5" extra="元"/>
      `,
      code8: `
  <yu-input title="银行卡" placeholder="请输入" name="myname5" format="bank"
            type="tel"/>
  <yu-input title="手机号" placeholder="请输入" name="myname5" format="phone"
            type="tel"/>
  <yu-input title="密码" placeholder="请输入" name="myname5" type="password"/>
  <yu-input title="数字键盘" placeholder="请输入" name="myname5" type="number"/>
      `,
      code9: `
  <yu-input title="名字" placeholder="请输入名字" name="myname2" readonly/>
      `,
      code10: `
  <yu-input title="名字" placeholder="请输入名字" name="myname2" disabled/>
      `,
      code11: `
  <yu-lists>
      <yu-input title="名字" placeholder="请输入名字" name="myname1"/>
      <yu-input title="名字" placeholder="请输入名字" name="myname2" autofocus/>
      <yu-input title="名字" placeholder="请输入名字" name="myname3" clear/>
  </yu-lists>
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'title',
          description: '输入框标题',
          types: 'String',
          default: '无',
        },
        {
          prop: 'showTitle',
          description: '是否显示输入框标题',
          types: 'Boolean',
          default: 'true',
        },
        {
          prop: 'icon',
          description: '输入框图标',
          types: 'String',
          default: '无',
        },
        {
          prop: 'imgSrc',
          description: '输入框图片地址',
          types: 'String',
          default: '无',
        },
        {
          prop: 'disabled',
          description: '禁用输入框',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'type',
          description: 'input原生属性',
          types: 'String',
          default: 'text',
        },
        {
          prop: 'name',
          description: 'input原生属性',
          types: 'String',
          default: '无',
        },
        {
          prop: 'placeholder',
          description: 'input原生属性',
          types: 'String',
          default: '无',
        },
        {
          prop: 'autofocus',
          description: 'input原生属性',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'readonly',
          description: 'input原生属性',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'defaultValue',
          description: '默认值',
          types: 'String',
          default: '无',
        },
        {
          prop: 'clear',
          description: '输入时显示可清除',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'extra',
          description: '额外文字，例如尾部单位',
          types: 'String',
          default: '无',
        },
        {
          prop: 'format',
          description: '输入格式类型[bank,phone]',
          types: 'String',
          default: '无',
        },
        {
          prop: 'rows',
          description: '多行显示时，设置行数',
          types: 'Number',
          default: '无',
        },
        {
          prop: 'textarea',
          description: '多行输入',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'max',
          description: '限制输入字数',
          types: 'Number',
          default: '无',
        },
        {
          prop: 'wordCount',
          description: '是否显示输入字数',
          types: 'Boolean',
          default: '无',
        },
      ],
      attributes2: [
        {
          event: '事件名称',
          description: '说明',
          callback: '回调参数',
        },
        {
          event: 'clear',
          description: '清除输入内容时触发',
          callback: '( event: Event )',
        },
        {
          event: 'keyup',
          description: '输入每个字符后触发',
          callback: '( event: Event )',
        },
        {
          event: 'blur',
          description: '失焦时触发',
          callback: '( event: Event )',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
      widths2: {
        event: '150px',
        description: '300px',
        callback: '320px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone {
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/input.vue